import addressTranslations from "./addressTranslations";
import organizationEmailTranslations from "./organizationEmailTranslations";

const organizationTranslation = {
  name: {
    label: "Name",
  },
  legalName: {
    label: "Name des Unternehmens",
  },
  mainEmail: organizationEmailTranslations,
  additionalEmails: { label: "Weitere E-Mail-Adressen" },
  telephone: {
    label: "Telefonnummer",
  },
  fax: {
    label: "Faxnummer",
  },
  address: addressTranslations,
  insolvencyStatus: {
    label: "Stand des Verfahrens",
    temporarily: "Vorläufig",
    open: "Eröffnet",
    rejected: "Abgewiesen (mangels Masse)",
  },
  insolvencyStartDate: {
    label: "Datum Insolvenzbeschluss",
  },
  strategicHints: {
    placeholder: "(Strategische) Hinweise zur Gegenseite",
    hint: "z.B. Adresse nicht zustellfähig, immer Klageverfahren notwendig, drohende Zahlungsunfähigkeit etc.",
  },
  hasInsolvency: {
    label: "Insolvenz",
  },
  informCasesAboutNewHints: {
    label: "Einmalig über neue Hinweise/Insolvenz per Aktivität an allen offenen Fällen informieren",
  },
};
export default organizationTranslation;
